import { useSound } from 'context/SoundProvider';
import { useAuth } from 'context/AuthProvider';
import { Volume2, VolumeX, User } from 'lucide-react';
import PageHero from 'components/PageHero';

export default function Settings() {
  const { muted, volume, toggleMute, setVolume, unlock } = useSound();
  const { user, logout } = useAuth();

  return (
    <div className="max-w-lg">
      <PageHero
        eyebrow="Preferences"
        title="Settings"
        showBack
        description="Sound, account, and session controls."
        icon={<User size={16} className="text-tp-gold" />}
      />

      <div className="glass-panel mt-6 divide-y divide-white/10">
        <div className="p-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              {muted ? <VolumeX className="text-white/60" /> : <Volume2 className="text-casino-gold" />}
              <div>
                <p className="font-medium">Sound Effects</p>
                <p className="text-xs text-white/50">Deal, chips, showdown, win &amp; timer</p>
              </div>
            </div>
            <button type="button" className="btn-outline px-4 py-2 text-xs" onClick={() => { unlock(); toggleMute(); }}>
              {muted ? 'Unmute' : 'Mute'}
            </button>
          </div>
          <div className="mt-4">
            <label className="mb-2 flex items-center justify-between text-xs text-white/50">
              <span>Volume</span>
              <span>{Math.round(volume * 100)}%</span>
            </label>
            <input
              type="range"
              min={0}
              max={100}
              value={Math.round(volume * 100)}
              onChange={(e) => {
                unlock();
                setVolume(Number(e.target.value) / 100);
              }}
              className="tp-volume-slider w-full"
            />
          </div>
        </div>

        {user && (
          <div className="flex items-center gap-3 p-4">
            <User className="text-casino-gold" />
            <div>
              <p className="font-medium">{user.username}</p>
              <p className="text-xs text-white/50">Player ID: {user.userId}</p>
            </div>
          </div>
        )}

        <div className="p-4">
          <button type="button" className="btn-danger w-full text-xs" onClick={logout}>
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
